import { convertQueryObjToString } from 'fe-common'

export default function({ query, route, redirect }) {
  if (
    query &&
    Object.keys(query).length > 0 &&
    Object.keys(query).some(key => Array.isArray(query[key]))
  ) {
    redirect(
      route.path +
        `?${convertQueryObjToString({
          ...query,
          ...Object.keys(query)
            .filter(key => Array.isArray(query[key]))
            .reduce((pre, cur) => {
              pre[cur] = query[cur][0]
              return pre
            }, {})
        })}`
    )
  }
}
